export default "Tabindex größer als 0\n|||\nEin Wert größer als 0 impliziert eine explizite Navigationsreihenfolge.\n|||\nBitte setzen Sie den Wert 0.\n";